export default __webpack_public_path__ + "static/media/qr-download.6b14f896.svg";